var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#F3F3F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8832 26.2463L28.2798 33.7425H26.3404L27.944 26.2463H29.8832ZM38.0422 31.0867L39.063 28.2717L39.6504 31.0867H38.0422ZM40.2067 33.7425H42L40.4334 26.2463H38.7792C38.4064 26.2463 38.0921 26.4624 37.953 26.7958L35.0431 33.7425H37.0799L37.4842 32.623H39.9719L40.2067 33.7425ZM35.1441 31.2952C35.1526 29.3169 32.4092 29.2073 32.4276 28.3233C32.4335 28.0547 32.6898 27.7686 33.2499 27.6954C33.5276 27.6597 34.2939 27.6307 35.1625 28.0309L35.5022 26.4407C35.0357 26.2719 34.4353 26.1094 33.6883 26.1094C31.7711 26.1094 30.4224 27.1277 30.4116 28.5872C30.3993 29.6664 31.375 30.2681 32.1086 30.6276C32.865 30.995 33.1184 31.2305 33.1147 31.5588C33.1094 32.0617 32.5116 32.2844 31.9549 32.2929C30.9793 32.308 30.4138 32.0292 29.9632 31.8191L29.6111 33.4624C30.065 33.6702 30.9013 33.8509 31.7672 33.8602C33.8054 33.8602 35.1381 32.8538 35.1441 31.2952ZM27.1121 26.2463L23.9699 33.7425H21.9202L20.3737 27.76C20.28 27.3921 20.1982 27.2569 19.9131 27.1014C19.4468 26.8482 18.6769 26.6113 18 26.4639L18.0459 26.2463H21.3457C21.7661 26.2463 22.1442 26.526 22.2405 27.0102L23.0574 31.3483L25.0747 26.2463H27.1121Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.9ca4d2f1d6535ed91fbb7ea45b5aa7b4.svg";
export { ForwardRef as ReactComponent };